import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const Cuenta1242TemporalFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuenta1242Temporal', salida.value)
      setFieldValue('cuenta1242TemporalInfo', salida.label)
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuenta1242Temporal', '')
    setFieldValue('cuenta1242TemporalInfo', '')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('select-cuentaContableTemporal1242')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='CTA TEMPORAL' htmlFor='select-cuentaContableTemporal1242' md={4} />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup
            id='cuentaContable1242Temporal'
            iValue={iValue}
            clickClear={clickClear}
          />
        ) : (
          <Select2CuentaContable
            id='select-cuentaContableTemporal1242'
            onlyAnalitica
            onChange={onChange}
          />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Cuenta1242TemporalFormGroup)
